import React, { useState, useCallback } from 'react';
import MarketNotificationDetailedHistory from './MarketNotificationDetailedHistory';

function MarketNotificationDetailedView({ selectedNotification }) {
    const [refreshHistoryDetail, setRefreshHistoryDetail] = useState(true);

    const refreshNotificationDetailedList = useCallback(async (flag) => {
        setRefreshHistoryDetail(flag);
    }, []);

    return (
        <>
            <MarketNotificationDetailedHistory
                refreshHistory={refreshHistoryDetail}
                refresh={(flag) => refreshNotificationDetailedList(flag)}
                selectedNotification={selectedNotification}
            />
        </>
    );
}

export default MarketNotificationDetailedView;
